import apiConfig from '../../../../../config/api'
import { apiRequestorHelper } from '../../../../../helpers'

const itemsService = {
  getCDIForm: (id, type) => {
    return apiRequestorHelper({
  		url: apiConfig.url + '/portal/getCDIFormStakeholder',
  		method: 'post',
      body: { id, type }
  	})
  }
}
export default itemsService